import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BzProgressTone = 'secondary' | 'success' | 'warning' | 'danger';

/**
 * A determinate progress bar.
 *
 * Tone is an explicit input rather than being derived from the value. The
 * legacy console's linear progress picked low/mid/high itself from
 * hard-coded 50% and 85% thresholds, which encodes one feature's idea of
 * "getting full" (vehicle capacity) into every other use of a progress bar.
 * A caller that wants that mapping does it at the call site.
 */
@Component({
  selector: 'bz-progress',
  templateUrl: './bz-progress.html',
  styleUrl: './bz-progress.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzProgress {
  readonly value = input(0);
  readonly max = input(100);
  readonly tone = input<BzProgressTone>('secondary');
  readonly ariaLabel = input('');

  /** Clamped, so a value outside the range cannot overflow the track. */
  readonly percent = computed(() => {
    const max = this.max();
    if (max <= 0) {
      return 0;
    }
    return Math.min(100, Math.max(0, (this.value() / max) * 100));
  });

  protected readonly barClass = computed(() => `bz-progress__bar bz-progress__bar--${this.tone()}`);
}
